import type { Messages } from '../messages.js'

/** European Portuguese. `viradas` for flips, which is literally what a tile does. */
export const pt: Messages = {
  tag: 'pt',

  readingDictionary: 'A ler o dicionário…',
  noWordList: 'Sem lista de palavras para "{language}". Gere uma:  pnpm dictionary build',
  emptyWordList: 'A lista de palavras para "{language}" está vazia.',

  flips: 'viradas',
  score: 'pontos',
  words: 'palavras',
  round: 'ronda',
  ticksLeftLabel: 'Tempo restante nesta ronda',
  typeAWord: 'escreva uma palavra',
  tapPrompt: 'toque para tomar ou devolver, depois {action}',

  boardOfTiles: 'Tabuleiro de {n} peças',
  faceDown: 'voltada para baixo',
  wildCard: 'coringa',
  wildKey: 'qualquer letra',
  letterReplaced: '{from} passou a {to}',
  letterSwap: 'TROCA DE LETRA!',
  spentTile: 'peça gasta',
  hiddenWhilePaused: 'oculta em pausa',
  letterInWord: '{letter}, letra {position} da palavra',

  completeWord: 'Completar palavra',
  completeShort: 'Completar',
  reset: 'Limpar',
  pause: 'Pausa',
  resume: 'Continuar',
  newGame: 'Novo jogo',
  paused: 'Em pausa',
  outOfFlips: 'Sem viradas',
  finalResult: '{score} pontos com {words} em {rounds}',
  playAgain: 'Jogar de novo',
  share: 'Partilhar',
  shareCopied: 'Copiado.',
  shareSelect: 'Copie isto:',

  lettersSelect: 'as letras selecionam',
  keysWild: 'usado quando escreve uma letra que nenhuma peça mostra',
  clearsEvery: 'retira todos os {letter} selecionados',
  undoLastLetter: 'desfaz a última letra',
  noWordsYet: 'Ainda nenhuma palavra.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'já encontrada',
  reasonTooShort: 'demasiado curta',
  reasonNotAWord: 'não é uma palavra',
  reasonAllFound: 'já os tem todos',
  noSuchLetterUp: 'nenhum {letter} à vista',
  nothingUp: 'nada à vista',
  letterHidden: 'uma letra ocultou-se',
  shuffled: 'baralhado',
  shuffledAndBilled: 'baralhado, cobradas {flips} viradas não usadas',
  tooFewLetters: 'Restam poucas letras',

  gameLanguage: 'idioma',
  interfaceLanguage: 'interface',
  dictionarySize: '{common} comuns de {full} palavras',
  filterLanguages: 'Procurar idiomas',
  noMatches: 'Sem resultados',

  nerdMode: 'modo técnico',
  rules: 'Regras',
  difficulty: 'dificuldade',
  difficultyNames: { easy: 'fácil', medium: 'médio', hard: 'difícil', insane: 'brutal' },
  pausedNoBoard: 'Este jogo não vai aparecer na classificação.',
  about: 'Sobre',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradicional', light: 'claro', contrast: 'alto contraste' },
  tiles: 'peças (N)',
  secondsPerTick: 'segundos / tempo',
  holdTicks: 'tempos de espera',
  minWord: 'palavra mínima',
  startingFlips: 'viradas iniciais',
  wildChance: 'probabilidade de coringa',
  replaceChance: 'probabilidade de troca de letra',
  hideChance: 'probabilidade de ocultar letra',
  wordCompleteMode: 'palavra completa',
  wordCompleteNames: { shuffle: 'baralhar', spend: 'gastar', keep: 'manter' },
  flipEconomy: 'economia de viradas',
  flipEconomyNames: {
    none: 'nenhuma',
    perLetter: 'por letra',
    fibonacci: 'fibonacci',
    overMinimum: 'acima do mínimo',
  },
  repeatedLetterKey: 'tecla de letra repetida',
  keySchemeNames: { cycle: 'ciclar', advance: 'avançar' },
  keySchemeHelp: {
    cycle:
      'A toma o próximo A livre e, quando estão todos na palavra, retira-os. ' +
      'Shift+A também os retira.',
    advance: 'A toma o próximo A livre. Shift+A retira todos os A da palavra.',
  },

  whatThatMeans: 'O que isso significa',
  factRound: 'uma ronda',
  factWholeBoardUp: 'tabuleiro todo à vista',
  factRoundCosts: 'uma ronda custa',
  factFlipsBuy: 'as viradas iniciais dão',
  factThisBoard: 'este tabuleiro',
  factBoardHadToAdmit: 'o tabuleiro tinha de admitir',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, a mais longa {longest}',
  wordsIncludingOneOf: '{words} incluindo uma de {ceiling}',
  scorelessRounds: '{rounds} sem pontuar',

  whatAWordPays: 'O que rende uma palavra',
  columnLetters: 'letras',
  columnCost: 'custo',
  columnPoints: 'pontos',
  columnFlips: 'viradas',
  columnNet: 'líquido',

  canonicalRules: 'Regras {difficulty} oficiais.',
  customRules: 'Alterado da predefinição. Pontuações com regras próprias não são classificadas.',
  applyAndStart: 'Aplicar e começar um jogo',
  changesNextGame: 'As alterações aplicam-se no próximo jogo.',
  presets: 'Predefinições:',

  start: 'Começar',
  restart: 'Reiniciar',
  quit: 'Sair',
  quitTitle: 'Sair deste jogo?',
  restartTitle: 'Reiniciar este jogo?',
  restartConfirm: 'Reiniciar',
  quitConfirm: 'Sair',
  keepPlaying: 'Continuar a jogar',
  personalBest: 'Os seus melhores jogos',
  newPersonalBest: 'Novo recorde pessoal.',
  columnRank: '#',
  notRanked: 'Regras próprias: este jogo não é classificado.',
  notRankedPaused: 'O relógio parou: este jogo não é classificado.',
  rankOfTotal: '{rank} de {total}',

  howToPlay: 'Como jogar',

  backToGame: 'Voltar ao jogo',
  welcomeTitle: 'Bem-vindo ao Blinkered',
  tutorialSkip: 'Ignorar',
  tutorialNext: 'Seguinte',
  tutorialBack: 'Voltar',
  tutorialStart: 'Começar a jogar',
  tutorialHideAgain: 'Não mostrar novamente',
  tutorialProgress: '{n} de {total}',
  tutorialSkipTitle: 'Ignorar a apresentação?',
  tutGoalTitle: 'Blinkered é uma corrida',
  tutGoalBody:
    'Começa o jogo com um número fixo de viradas, e cada peça que vira custa uma virada. Quando as viradas acabam, o jogo termina. Formar palavras rende viradas, e quanto mais longa for a palavra, mais viradas ganha.',
  tutSpentBody:
    'As letras que usar numa palavra ficam viradas ao contrário até à ronda seguinte. Só uma troca de letra muda as letras que estão no tabuleiro.',
  tutChangeTitle: 'As letras podem mudar',
  tutSameLetters:
    'Viu uma palavra que não chegou a jogar? As mesmas letras voltam na ronda seguinte, baralhadas noutros lugares.',
  tutPickLetters: 'Toque nas letras que quiser, pela ordem, para formar uma palavra.',
  tutMoreTurn:
    'As peças continuam a virar enquanto pensa, por isso ainda pode aparecer uma letra melhor.',
  tutTapBack:
    'Tocou numa sem querer? Toque outra vez para a devolver. Em qualquer uma, não só na última.',
  tutComplete: 'Carregue em Concluir quando a palavra estiver pronta.',
  htBoardTitle: 'O tabuleiro',
  htBoardBody:
    'As peças viram-se uma a uma, numa ordem aleatória. As peças à vista servem para formar palavras.',
  htWordsTitle: 'As palavras',
  htWordsBody:
    'Forme uma palavra com as peças à vista, escrevendo ou clicando nas letras pela ordem.',
  htFlipsTitle: 'As viradas',
  htFlipsBody:
    'Cada peça que vira custa uma virada. Uma palavra completa devolve viradas ao seu total, e as palavras longas devolvem mais. Quando as viradas acabam, o jogo termina.',
  htRoundTitle: 'A ronda',
  htRoundBody:
    'Quando vira a última peça de uma ronda, o tabuleiro fica todo à vista por um momento. Depois as peças são viradas ao contrário e baralhadas, e começa uma ronda nova.',
  htLanguagesTitle: 'Os idiomas',
  htLanguagesBody:
    '{n}. Cada tabuleiro pode ser resolvido com palavras de uso corrente. Uma palavra invulgar também pontua, se o dicionário a conhecer.',
  htKeysTitle: 'O teclado',
  htWildTitle: 'Os coringas',
  htWildBody:
    'Às vezes aparece um coringa em vez de uma letra. Um coringa vale qualquer letra que forme uma palavra válida. Uma palavra já completada não conta.',
  htHideTitle: 'Letras que se ocultam',
  htHideBody:
    'Nos níveis mais difíceis uma letra visível pode voltar a virar-se sozinha e regressar mais tarde na ronda. O temporizador ganha um traço por isso, em vermelho. As letras já tomadas não se viram.',
  tutHideBody:
    'Nos níveis mais difíceis uma letra visível pode voltar a virar-se sozinha e regressar mais tarde na ronda. As letras já tomadas não se viram.',
  htSwapTitle: 'As letras mudam',
  htSwapBody:
    'Às vezes, entre rondas, uma letra é substituída por outra. Vai ver qual foi retirada e qual foi acrescentada.',
  htLevelsTitle: 'Os níveis',
  htLevelEasy:
    'As mesmas doze letras durante toda a partida: pode aprendê-las e guardar uma lista de palavras de cabeça. As peças viram devagar e o tabuleiro completo fica à vista tempo suficiente para acabar de escolher as letras.',
  htLevelMedium:
    'De vez em quando uma letra muda, por isso torna-se mais difícil guardar as palavras que queria jogar mais à frente. Menos tempo para olhar e menos para pensar.',
  htLevelHard:
    'As palavras de três letras deixam de contar e uma letra muda mais ou menos de duas em duas rondas. O tabuleiro mal aparece e já baralha.',
  htLevelInsane:
    'Tudo ao mesmo tempo, a toda a velocidade. O tabuleiro é baralhado quase logo a seguir à última virada.',
  htTouchTitle: 'O ecrã tátil',
  htTouchBody:
    'Toque numa peça virada para tomar a sua letra. Toque numa letra já tomada para a devolver. Completar e Limpar ficam sob o tabuleiro.',

  accountTitle: 'A sua conta',
  menuProfile: 'O meu perfil',
  menuGames: 'Os meus jogos',
  menuPublicPage: 'A minha página pública',
  menuSignedInAs: 'Sessão iniciada como',
  signIn: 'Iniciar sessão',
  signOut: 'Terminar sessão',
  signInTitle: 'Inicie sessão ou registe-se',
  signInLead: 'Uma conta guarda os seus jogos, em todos os dispositivos.',
  signInKeepGame: 'Inicie sessão para guardar este jogo, e todos os seguintes.',
  continueWithApple: 'Continuar com a Apple',
  continueWithGoogle: 'Continuar com o Google',
  signInOr: 'ou',
  emailLabel: 'E-mail',
  codeLabel: 'Código',
  emailMeACode: 'Enviem-me um código',
  working: 'Um momento…',
  sendNewCode: 'Enviar um código novo',
  codeSent: 'Veja o seu e-mail. O código dura 10 minutos.',
  notNow: 'Agora não',
  badEmail: 'Isso não parece um endereço de e-mail.',
  badCode:
    'Esse código não funcionou. Os códigos expiram ao fim de 10 minutos e só servem uma vez.',
  serverBusy: 'Não foi possível contactar o servidor. Tente daqui a pouco.',
  serverDown: 'Não foi possível contactar o servidor.',
  offline: 'Sem ligação',
  leaderboardTitle: 'Classificação',
  leaderboardEmpty: 'Ainda não há jogos nesta classificação. Sê o primeiro.',
  leaderboardWouldBe: 'Onde ficaria este jogo',
  leaderboardThisGame: 'Este jogo',
  leaderboardRanksHere: 'Onde fica este jogo',
  leaderboardOutside: 'Fora das cinco primeiras.',
  tutAccountTitle: 'Guarda as tuas pontuações',
  tutAccountBody:
    'Uma conta guarda os teus jogos, põe as tuas pontuações na classificação e mantém o teu perfil.',
  ssoCancelled: 'Início de sessão cancelado.',
  ssoExpired: 'Demorou demasiado. Inicie sessão outra vez.',
  ssoNoUsername: 'Não foi possível terminar de criar a conta. Tente daqui a pouco.',
  ssoFailed: 'Não funcionou. Tente outra vez, ou use o seu e-mail.',
  tabProfile: 'Perfil',
  countryAny: 'Prefiro não dizer',
  findCountry: 'Procurar países',
  usernameLabel: 'Nome de utilizador',
  bioLabel: 'Bio',
  countryLabel: 'País',
  bioHint: 'Sem ligações. {left}/{max}',
  save: 'Guardar',
  saving: 'A guardar…',
  saved: 'Guardado.',
  nameTaken: 'Esse nome já é de alguém.',
  nameTooShort: 'Um pouco mais longo, por favor.',
  nameTooLong: 'É demasiado longo.',
  nameBadCharacters: 'Apenas letras, algarismos, hífenes e sublinhados.',
  nameBadEdges: 'Tem de começar e acabar com uma letra ou um algarismo.',
  nameMixedScripts: 'Escolha um alfabeto e fique por ele.',
  nameReserved: 'Parece um nome que nós próprios atribuímos. Escolha outro.',
  nameUnusable: 'Esse nome não pode ser usado.',
  bioTooLong: 'As bios têm no máximo {max} caracteres.',
  bioHasLink: 'Não são permitidas ligações numa bio.',
  bioHasControl: 'Contém caracteres que uma bio não pode ter.',
  bioUnusable: 'Essa bio não pode ser usada.',
  gamesHeading: 'Jogos',
  gamesEmpty: 'Ainda não há nada aqui. Os jogos que fizer com sessão iniciada aparecem aqui.',
  gamesEmptyShort: 'Ainda não há nada aqui.',
  gamesLoading: 'A ler os seus jogos…',
  theirGamesLoading: 'A ler os jogos dele…',
  profileLoading: 'A ler o perfil…',
  playerNotFound: 'Não há aqui ninguém com esse nome.',
  columnWhen: 'Quando',
  columnRounds: 'rondas',
  columnGame: 'Jogo',
  gameLoading: 'A ler o jogo…',
  gameUnreadable: 'Não foi possível ler este jogo.',
  gameNotRanked: 'Jogado com regras alteradas, por isso não conta para a classificação.',
  detailNotKept: 'As palavras e os tabuleiros deste jogo já não são guardados.',
  openingBoard: 'O tabuleiro inicial',
  roundByRound: 'Ronda a ronda',
  roundNothing: 'nada encontrado',
  changeReplaced: '{letter} substituída na casa {slot}',
  changeWildOn: '{letter} joker na casa {slot}',
  changeWildOff: '{letter} joker retirado da casa {slot}',
  keepThisGame: 'Guardar este jogo',
  savedToYourGames: 'Guardado nos seus jogos.',

  reportThis: 'Denunciar',
  reportHeading: 'Denunciar isto',
  reportTheName: 'O nome',
  reportTheBio: 'A descrição',
  reportTheScore: 'A pontuação',
  reportWhy: 'O que está errado? Opcional.',
  reportSend: 'Enviar a denúncia',
  reportSent: 'Obrigado. Alguém vai ver isso.',
  reportSignIn: 'Inicia sessão para denunciar algo.',
  reportGone: 'Isso já não existe.',
  reportCancel: 'Cancelar',

  deleteAccount: 'Eliminar a minha conta',
  deleteAccountWhat:
    'Isto remove o teu perfil e todos os jogos que guardaste, para sempre. Não pode ser desfeito.',
  deleteAccountAsk: 'Envia-me um código',
  deleteConfirm: 'Eliminar para sempre',
  deleteGone: 'A tua conta já não existe. Obrigado por jogares.',
  deleteNoAddress:
    'Não há um endereço confirmado nesta conta, por isso uma eliminação não pode ser verificada. Fala com nós e fazemos isso à mão.',

  rulesetFacts: 'Palavras de {letters} · uma peça nova a cada {seconds}',
  plurals: {
    words: { one: '{n} palavra', other: '{n} palavras' },
    rounds: { one: '{n} ronda', other: '{n} rondas' },
    flips: { one: '{n} virada', other: '{n} viradas' },
    ticks: { one: '{n} tempo', other: '{n} tempos' },
    points: { one: '{n} ponto', other: '{n} pontos' },
    minLetters: { one: '{n} letra ou mais', other: '{n} letras ou mais' },
    seconds: { one: '{n} segundo', other: '{n} segundos' },
  },
}
